import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";

import { getAcknowledgeLevelPath } from "../resources/unacknowledgedLevel/unacknowledgedLevelResourceConsts";

export type AcknowledgeLevelPayload = {
  levelGroupId: string;
  levelId: string;
};

export function acknowledgeLevelMutation(jsonApi: JsonApiClient) {
  return ({ levelGroupId, levelId }: AcknowledgeLevelPayload) =>
    jsonApi.createOne({
      path: getAcknowledgeLevelPath(levelGroupId, levelId),
    });
}
